import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { Table } from "@pentabd/ui";

import { TableColumn } from "./TableColumn";

import { useDemandList } from "@hooks/procurements/demand/useDemandList";

import { TablePagination } from "@helpers/tablePagination";

import { DemandResponseType } from "@type/procurements/demand";
import { Pagination } from "@type/procurements/pagination";

export default function ProcurementDemandListTable({
  handleSelectedDemand,
  demandIds,
  demands,
}: {
  selectedProducts: any;
  handleSelectedDemand: (id: number) => void;
  demandIds: number[];
  demands: any;
}) {
  const { t } = useTranslation();

  const { handleQuery, demandState } = useDemandList();

  const { getData, createSuccess, deleteSuccess } = demandState;

  const { data, pagination } = getData || ({} as DemandResponseType);
  const { page, total } = pagination || ({} as Pagination);

  useEffect(() => {
    if (createSuccess === true) handleQuery("page", 1);
    else if (deleteSuccess === true) handleQuery("page", page);
  }, [createSuccess, deleteSuccess]);

  console.log("ProcurementDemandListTable data", data, "demands", demands);

  return (
    <>
      <Table
        header={{
          title: t("PROCUREMENT_DEMAND.DEMAND_LIST.TABLE_HEADING"),
          badge: {
            label: `${demands ? demands.length : total}`,
            size: "sm",
            type: "primary",
          },
        }}
        columns={TableColumn(t, handleSelectedDemand, demandIds, demands)}
        rows={demands ? demands : data || []}
        pagination={TablePagination(
          demands
            ? {
                page: 1,
                size: 1000,
                total: demands?.length,
              }
            : pagination,
          handleQuery,
        )}
        isStickyHeader
        height={(demands?.length ?? 0) > 5 ? 500 : undefined}
      />
    </>
  );
}
